// extracted by mini-css-extract-plugin
export var section = "styles-module--section--37Is5";
export var tituloCategoria = "styles-module--tituloCategoria--1WNQ5";